var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4",attrs:{"elevation":"0"}},[_c('pie-chart',{attrs:{"chart-data":_vm.pieData,"options":_vm.OfertasTipoOptions},on:{"generated":_vm.setLegend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }